import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-flight-details-diff-item',
  templateUrl: './flight-details-diff-item.component.html',
  styleUrls: ['./flight-details-diff-item.component.scss']
})
export class FlightDetailsDiffItemComponent implements OnInit {
  @Input() flight: any;
  @Input() diffs: string[] = [];
  @Input() type: 'old' | 'new';
  @Input() diffType: 'modified' | string;

  constructor() { }

  ngOnInit(): void {
  }

}
